<template>
    <div class="tw-grid tw-grid-cols-5 tw-gap-8">
        <div class="tw-col-start-4">
            <button type="button" class="btn btn-link btn-block" @click="$emit('download')">
                <i class="fa fa-download"></i> Download
            </button>
        </div>

        <div >
            <DateWidget :value="year" @input="$emit('update:year', $event)" format="YYYY" original-format="YYYY"/>
        </div>
    </div>
</template>

<script>
import DateWidget from '../../../../../../../vendor/forms/FormGroups/Widgets/Date'

export default {
    components: {DateWidget},

    props: {
        year: {
            required: true
        }
    }
}
</script>
